<template lang="pug">
  include ./../../../mixins
  +b.stats
    +e.header
      +b.ug-row--apearance_spaced.--space_xs.--justify_between.--align_center
        +b.ug-cell
          +b.TEXT-BEMTO(
            :fw="'bold'"
            :lh="'initial'"
            :fs="['md', '1md-md', 'xl-fhd']"
            :color="'black'"
            :tag="'p'"
          ) SMS SERVICE
        +b.ug-cell
          +b.stats__icon.icon--type_message
    +e.body
      validation-observer(
        ref="observer"
        tag="form"
        class="form"
      )
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12
            +b.input.D-CONTROL-INPUT(
              v-model="formData.phone"
              :placeholder="'Phone Number *'"
              :rules="'required|ukPhone'"
              :name="'phone'"
              :type="'tel'"
              id="phone"
            )
          +b.ug-cell.ug-cols--12
            +b.cabinet-textarea
              +b.input.D-CONTROL-TEXTAREA(
                v-model="formData.message"
                :placeholder="'Comments *'"
                :rules="'required'"
                :name="'message'"
                :type="'text'"
                id="message"
              )
              +e.action.button--copy.BUTTON-BEMTO(
                :disabled="isRequest"
                @event="validateBeforeSubmit(formData)"
              )
                +b.icon--type_send
</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'
import { postSendSmsAPI } from '@/js/services/cabinet'

export default {
  name: 'SendMessageCabinet',
  mixins: [
    FormMixin,
    ToggleModalMixin
  ],
  data() {
    return {
      /**
       * Component state.
       */
      formData: {
        phone: null,
        message: null,
      },
      isRequest: false,
    }
  },
  methods: {
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      return postSendSmsAPI.execute(
        {}, data
      )
        .then(response => {
          const OPTIONS = {
            title: response.data.item.message,
          }
          /**
           * Clear component state.
           */
          this.$refs.observer.reset()
          this.clearComponentState()
          /**
           * Show success message.
           */
          this.toggleModalMixin(
            'SuccessCommon', OPTIONS
          )
        })
    },
    clearComponentState() {
      this.formData.phone = null
      this.formData.message = null
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/cabinets/SendMessageCabinet.vue